import { render, staticRenderFns } from "./GoodReceiveView.vue?vue&type=template&id=57bfd4f1&"
import script from "./GoodReceiveView.vue?vue&type=script&lang=js&"
export * from "./GoodReceiveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports